import React, { useState } from 'react';
import { Button, Container, Card, Collapse } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import * as SettingSelector from '../../store/setting/selectors'; 

const ErrorFallback = ({ error }) => {
  const [open, setOpen] = useState(false);
  
  const themeScheme = useSelector(SettingSelector.theme_scheme);
  const isDark = themeScheme === "dark";

  return (
    <div style={{ 
      backgroundColor: isDark ? '#151921' : '#f4f7f9', 
      minHeight: '100vh', 
      display: 'flex', 
      alignItems: 'center',
      justifyContent: 'center',
      transition: 'all 0.3s ease'
    }}>
      <Container>
        <Card 
          className={`shadow-lg border-0 text-center p-4 mx-auto ${isDark ? 'bg-dark text-white' : 'bg-white'}`} 
          style={{ 
            maxWidth: '600px', 
            borderRadius: '15px',
            border: isDark ? '1px solid #333' : 'none'
          }}
        >
          <Card.Body>
            <div style={{ fontSize: '60px', marginBottom: '20px' }}>⚠️</div>
            
            <h3 className="fw-bold" style={{ color: isDark ? '#fff' : '#232d4b' }}>
              Oops! Something went wrong
            </h3>
            
            <p className={`${isDark ? 'text-light' : 'text-muted'} mb-4`} style={{ opacity: 0.8 }}>
              "Something went wrong on our end. Our technical team has been notified."
            </p>

            <div className="d-flex justify-content-center gap-3 mb-4">
              <Button 
                variant={isDark ? "info" : "primary"} 
                className="px-4 py-2" 
                style={{ borderRadius: '8px', fontWeight: '500' }}
                onClick={() => window.location.assign('/dashboard')} 
              >
                Go to Dashboard
              </Button>
              
              <Button 
                variant={isDark ? "info" : "primary"} 
                className="px-4 py-2"
                style={{ borderRadius: '8px', fontWeight: '500'  }}
                onClick={() => window.location.reload()}
              >
                Reload Page
              </Button>
            </div>

            <hr style={{ borderColor: isDark ? '#444' : '#eee' }} />
            
            <div className="mt-3">
              <span 
                onClick={() => setOpen(!open)} 
                style={{ 
                  cursor: 'pointer', 
                  fontSize: '13px',
                  color: isDark ? '#5bc0de' : '#007bff'
                }} 
                className="text-decoration-underline"
              >
                {open ? 'Hide Technical Details' : 'Show Technical Details'}
              </span>
              
              <Collapse in={open}>
                <div className="mt-3 text-start">
                  <div 
                    className={`p-3 border rounded ${isDark ? 'bg-soft-dark' : 'bg-light'}`} 
                    style={{ 
                      maxHeight: '200px', 
                      overflowY: 'auto',
                      backgroundColor: isDark ? '#1c222c' : '#f8f9fa',
                      borderColor: isDark ? '#333' : '#ddd'
                    }}
                  >
                    <code style={{ fontSize: '12px', color: isDark ? '#ff79c6' : '#e83e8c' }}>
                      <strong>Error:</strong> {error?.toString() || "Unknown reference error"}
                    </code>
                  </div>
                </div>
              </Collapse>
            </div>
          </Card.Body>
        </Card>
      </Container>
    </div>
  );
};

export default ErrorFallback;